// firebase.js

import firebase from "firebase/compat/app"; // Update import statement
import "firebase/compat/messaging"; // Import Firebase Messaging module

const firebaseConfig = {
 apiKey: "AIzaSyAh43nftHQ5U6_ccpJZQ0ktIdheaqJIy-w",
  authDomain: "apnaadda-1bea5.firebaseapp.com",
  projectId: "apnaadda-1bea5",
  storageBucket: "apnaadda-1bea5.firebasestorage.app",
  messagingSenderId: "180195144243",
  appId: "1:180195144243:web:91d42d6af27119d8d66946",
  measurementId: "G-K4TJ8RJH17"
};

const app = firebase.initializeApp(firebaseConfig);

export default app; // Export the initialized Firebase app
